export default __webpack_public_path__ + "473c05dbf59db0e3239003f68e9cc61c.png";